import React from "react";
import { PieChart, Pie, Cell } from "recharts";
import DotsComponent from "./DotsComponent";

export default function PieCardRender({
  data,
  filling,
  pieColor,
  pieIndicator,
}) {
  return (
    <>
      <span className="card">
        <DotsComponent />
        <div className="card-up" style={{ gap: "0",marginTop:'0' }}>
          <div
            className="card-up-data card-pie-chart"
            style={{ background: "white" }}
          >
            <div className="pie-circle">
              <div className="pie-in-circle" />
            </div>
            <CardPieChart filling={filling} pieColor={pieColor} />
            <div className="pie-chart-in-data">
              <h1>{data.card1up1}</h1>
              <p>{data.card1up2}</p>
            </div>
          </div>
          <div className="card-down-data">
            <p className="card-down-data-left">
              <span style={{ backgroundColor: `${pieIndicator[0]}` }}></span>
              {data.dot1}
            </p>
            <p>
              <span style={{ backgroundColor: `${pieIndicator[1]}` }}></span>
              {data.dot2}
            </p>
          </div>
          <div className="card-down-data">
            <p className="card-down-data-left">
              <span style={{ backgroundColor: `${pieIndicator[2]}` }}></span>
              {data.dot3}
            </p>
            <p>
              <span style={{ backgroundColor: `${pieIndicator[3]}` }}></span>
              {data.dot4}
            </p>
          </div>
          <p style={{paddingTop:"5px"}}>{data.card1up3}</p>
        </div>
        <p className="card-dn-p" style={{marginTop:'5px'}}>{data.card1dnP}</p>
      </span>
    </>
  );
}

const CardPieChart = ({ filling, pieColor }) => {
  return (
    <>
      <PieChart width={800} height={400}>
        <Pie
          data={filling}
          cx={390}
          cy={210}
          innerRadius={175}
          outerRadius={250}
          fill="#8884d8"
          paddingAngle={-10}
          dataKey="value"
          cornerRadius={40}
          stroke-width={-10}
          startAngle={0}
        >
          {filling.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={pieColor[index % pieColor.length]}
            />
          ))}
        </Pie>
      </PieChart>
    </>
  );
};
